"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _columnTypes = _interopRequireDefault(require("./columnTypes"));
var _rowTypes = _interopRequireDefault(require("./rowTypes"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  var _super = _createSuper(Builder);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_renderColumn", function (column, columnField) {
      var label = column.label;
      var element = _columnTypes["default"][column.type.value];
      var defaultValue = element.defaultLabel || element.name;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: label,
        label: "Column Header Label",
        isWysiwyg: true,
        wysiwygProps: {
          autofocus: 'end',
          selectAllOnFocus: label.value === defaultValue
        }
      }), columnField, _this._renderCellWidthAndPosition(column), _this._renderCellWidthAndPosition({
        position: column.headerPosition,
        isCellExpanded: column.isHeaderExpanded,
        title: 'Header position'
      }), _this._renderTemplateBlock(column));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderRow", function (row, rowField) {
      var label = row.label;
      var element = _rowTypes["default"][row.type.value];
      var defaultValue = element.defaultLabel || element.name;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: label,
        label: "Label",
        isWysiwyg: true,
        wysiwygProps: {
          autofocus: 'end',
          selectAllOnFocus: label.value === defaultValue
        }
      }), rowField, _this._renderCellWidthAndPosition(_objectSpread(_objectSpread({}, row), {}, {
        title: 'Cell position'
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderCellWidthAndPosition", function (_ref) {
      var isCellExpanded = _ref.isCellExpanded,
        position = _ref.position,
        width = _ref.width,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? 'Cell width and position' : _ref$title;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: title,
        show: isCellExpanded.value,
        handleClick: function handleClick(show) {
          return isCellExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'row ' + _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Position in a cell"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].radioRow
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "top-left",
        checked: position.value === 'top-left'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "top-center",
        checked: position.value === 'top-center'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "top-right",
        checked: position.value === 'top-right'
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].radioRow
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "middle-left",
        checked: position.value === 'middle-left'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "middle-center",
        checked: position.value === 'middle-center'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "middle-right",
        checked: position.value === 'middle-right'
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].radioRow
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "bottom-left",
        checked: position.value === 'bottom-left'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "bottom-center",
        checked: position.value === 'bottom-center'
      })), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(position), {
        value: "bottom-right",
        checked: position.value === 'bottom-right'
      }))))), width && /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: width,
        label: "Cell width",
        comment: "e.g. 30% or 200px"
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTemplateBlock", function (column) {
      var template = column.template,
        templateSettings = column.templateSettings,
        isTemplateExpanded = column.isTemplateExpanded;
      var availableTemplates = _this.props.availableComponentTemplates[column.type.value] || [];
      function onTemplateChange(event) {
        var newTemplateName = event.target.value;
        var newTemplate = (0, _find2["default"])(availableTemplates, {
          name: newTemplateName
        });
        var newTemplateSettings = newTemplate ? newTemplate.defaultSettings : {};
        template.onChange(newTemplateName);
        templateSettings.onChange(newTemplateSettings);
      }
      var templateSettingsComponent = null;
      if (template.value !== '') {
        var currentTemplate = (0, _find2["default"])(availableTemplates, {
          name: template.value
        });
        if (currentTemplate) {
          var SettingsComponent = currentTemplate.settingsComponent;
          if (SettingsComponent) {
            templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
              initialValues: _objectSpread(_objectSpread({}, currentTemplate.defaultSettings), templateSettings.value),
              onChange: templateSettings.onChange,
              settings: column,
              DataConnectorsPicker: _this.props.DataConnectorsPicker
            });
          }
        }
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Template",
        show: isTemplateExpanded.value,
        handleClick: function handleClick(show) {
          return isTemplateExpanded.onChange(show);
        }
      }, availableTemplates.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, "There are no templates available") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: !templateSettingsComponent ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: template,
        label: "Template",
        comment: "Some templates could override element settings"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(template), {
        className: "form-control",
        style: {
          width: 'auto'
        },
        onChange: onTemplateChange
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Default --"), availableTemplates.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: item.name,
          key: item.name
        }, item.title);
      })))), templateSettingsComponent));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderOptions", function () {
      var _this$props$fields = _this.props.fields,
        rowHeaderWidth = _this$props$fields.rowHeaderWidth,
        cornerHeader = _this$props$fields.cornerHeader,
        isBorderedStyle = _this$props$fields.isBorderedStyle,
        isStripedRowsStyle = _this$props$fields.isStripedRowsStyle,
        isStripedColumnsStyle = _this$props$fields.isStripedColumnsStyle;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Table style"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isBorderedStyle))), " Bordered")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isStripedRowsStyle))), " Striped rows")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isStripedColumnsStyle))), " Striped columns"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: rowHeaderWidth,
        label: "Row header width",
        placeholder: "e.g. 30%"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: cornerHeader,
        label: "Row label header",
        isWysiwyg: true
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_changeQuestionNumbersReset", function (event) {
      var _this$props$fields2 = _this.props.fields,
        questionNumbersReset = _this$props$fields2.questionNumbersReset,
        questionNumbersResetNumber = _this$props$fields2.questionNumbersResetNumber;
      questionNumbersReset.onChange(event);
      questionNumbersResetNumber.onChange('1');
    });
    _defineProperty(_assertThisInitialized(_this), "_renderQuestionNumbersBlock", function () {
      var _this$props$fields3 = _this.props.fields,
        questionNumbersExpanded = _this$props$fields3.questionNumbersExpanded,
        questionNumbersHide = _this$props$fields3.questionNumbersHide,
        questionNumbersForMainQuestion = _this$props$fields3.questionNumbersForMainQuestion,
        questionNumbersForRows = _this$props$fields3.questionNumbersForRows,
        questionNumbersReset = _this$props$fields3.questionNumbersReset,
        questionNumbersResetNumber = _this$props$fields3.questionNumbersResetNumber;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Question numbers",
        type: "primary",
        show: questionNumbersExpanded.value,
        handleClick: function handleClick(show) {
          return questionNumbersExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        value: !questionNumbersHide.value,
        checked: !questionNumbersHide.value,
        onChange: function onChange() {
          return questionNumbersHide.onChange(!questionNumbersHide.value);
        }
      }), ' ', "Show numbers")), !questionNumbersHide.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(questionNumbersForMainQuestion))), " Show question number")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(questionNumbersForRows))), " Show number for each rows")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(questionNumbersReset), {
        onChange: _this._changeQuestionNumbersReset
      })), ' ', "Reset to specific number")), questionNumbersReset.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow,
        style: {
          marginTop: '.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: questionNumbersResetNumber,
        label: "Start number",
        inputStyle: {
          width: '60px'
        }
      }))));
    });
    return _this;
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields4 = this.props.fields,
        question = _this$props$fields4.question,
        description = _this$props$fields4.description,
        columns = _this$props$fields4.columns,
        columnTypes = _this$props$fields4.columnTypes,
        rows = _this$props$fields4.rows,
        rowTypes = _this$props$fields4.rowTypes,
        minUserRows = _this$props$fields4.minUserRows,
        maxUserRows = _this$props$fields4.maxUserRows,
        allowUserRows = _this$props$fields4.allowUserRows,
        addUserRowText = _this$props$fields4.addUserRowText,
        userRowPlaceholder = _this$props$fields4.userRowPlaceholder;
      var dynamicUserLists = this.props.dynamicUserLists;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        type: "textarea-inline",
        onChange: question.onChange,
        selectAllOnFocus: question.value === _settings.initialValues.question
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        type: "textarea-inline",
        onChange: description.onChange
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Rows ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, rows.length)),
        type: "primary",
        isError: (0, _cccisdSurveyCommon.checkForErrors)([rows, rowTypes, minUserRows, maxUserRows]),
        show: true
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
        constant: "ROW",
        elements: rows,
        elementTypes: _rowTypes["default"],
        elementFields: rowTypes,
        renderElement: this._renderRow,
        dragHint: "Drag rows here",
        moveOnTab: true,
        extraProps: {
          dynamicUserLists: dynamicUserLists
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: !allowUserRows.value ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(allowUserRows))), " Allow user-added rows"))), allowUserRows.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: addUserRowText,
        label: "Button display text"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: userRowPlaceholder,
        label: "Input box placeholder text"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'row ' + _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minUserRows,
        label: "Min user-added rows"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxUserRows,
        label: "Max user-added rows"
      }))))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Columns ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, columns.length)),
        type: "primary",
        isError: (0, _cccisdSurveyCommon.checkForErrors)([columns, columnTypes]),
        show: true
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
        ref: "column",
        constant: "COLUMN",
        elements: columns,
        elementTypes: _columnTypes["default"],
        elementFields: columnTypes,
        renderElement: this._renderColumn,
        dragHint: "Drag columns here",
        initialValues: {
          position: 'top-left'
        }
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Settings",
        type: "primary",
        show: true
      }, this._renderOptions()), this._renderQuestionNumbersBlock());
    }
  }]);
  return Builder;
}(_react["default"].Component);
exports.Builder = Builder;
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  formBlockType: _propTypes["default"].string,
  availableComponentTemplates: _propTypes["default"].object,
  DataConnectorsPicker: _propTypes["default"].func,
  dynamicUserLists: _propTypes["default"].array
});
_defineProperty(Builder, "defaultProps", {
  formBlockType: 'primary'
});
var _default = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withVisibilityConditions: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withDefaultValueFromVariable: true
})(Builder);
exports["default"] = _default;